export const WEBSITE_SUFFIX_MAP = {
  "https://alwsata.com.sa": "/referral/",
  "https://suyulasa.com": "/financials/",
  "https://hasbah.net": "/ask-for-funding/",
  "https://nomoufinance.com": "/ask-for-funding/",
};

// Short Arabic labels for the same four sites. The reports show these rather than
// the domain: a Latin domain in a narrow RTL column wraps or truncates.
export const WEBSITE_NAME_MAP = {
  "https://alwsata.com.sa": "الوساطة",
  "https://suyulasa.com": "سيولة",
  "https://hasbah.net": "حسبة",
  "https://nomoufinance.com": "نمو",
};

export function referralSiteName(website) {
  return WEBSITE_NAME_MAP[website] || "";
}

// The bare domain, for places that show the link itself (alwsata.com.sa).
export function referralSiteDomain(website) {
  return website ? String(website).replace(/^https?:\/\//i, "") : "";
}

export function referralSitePrefix(website) {
  const path = WEBSITE_SUFFIX_MAP[website];
  return website && path ? website + path : "";
}

export function buildReferralUrl(website, suffix) {
  if (!suffix) return "";
  // Legacy rows may still store a full URL in the suffix column; use it as-is.
  if (/^https?:\/\//i.test(suffix)) return suffix;
  const prefix = referralSitePrefix(website);
  return prefix ? prefix + suffix : suffix;
}

// Collapses the ways a user may type a referral link (pasted from the browser,
// copied without the scheme, with tracking params) onto one comparable form.
export function normalizeReferralUrl(value) {
  return String(value == null ? "" : value)
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, "")
    .replace(/^www\./, "")
    .replace(/[?#].*$/, "")
    .replace(/\/+$/, "");
}
